<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/charts/statistics' }">首页</el-breadcrumb-item> -->
      <!-- <el-breadcrumb-item>数据可视化</el-breadcrumb-item> -->
    </el-breadcrumb>
    <!-- 搜索，切换 -->
<!--    <el-row :gutter="23">-->
<!--      <el-col :span="7">-->
<!--        <div class="stbgc">-->
<!--          <el-row :gutter="23">-->
<!--            <el-col :span="24">-->
<!--              <el-select v-model="value" size="small" class="full_select" placeholder="请选择">-->
<!--                <el-option-->
<!--                  v-for="item in options"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-col>-->
<!--            &lt;!&ndash; <el-col :span="7">-->
<!--              <el-input size="small" v-model="machineNo" placeholder="请输入资产编号"></el-input>-->
<!--            </el-col>-->
<!--            <el-col :span="7">-->
<!--              <el-input size="small" v-model="machineNo" placeholder="请输入"></el-input>-->
<!--            </el-col>-->
<!--            <el-col :span="3" class="stsearch">-->
<!--              <el-button size="small" type="primary">搜索</el-button>-->
<!--            </el-col> &ndash;&gt;-->
<!--          </el-row>-->
<!--        </div>-->
<!--      </el-col>-->
<!--      <el-col :span="6">-->
<!--        <div class="stbgc">-->
<!--          <el-row>-->
<!--            <el-col :span="8" class="text-c">-->
<!--              <el-radio v-model="type" label="day">周</el-radio>-->
<!--            </el-col>-->
<!--            <el-col :span="8" class="text-c">-->
<!--              <el-radio v-model="type" label="month">月</el-radio>-->
<!--            </el-col>-->
<!--            <el-col :span="8" class="text-c">-->
<!--              <el-radio v-model="type" label="years">年</el-radio>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </div>-->
<!--      </el-col>-->
<!--      <el-col :span="6">-->
<!--        <div class="stbgc">-->
<!--          <el-row>-->
<!--            <el-date-picker-->
<!--            size="small"-->
<!--              v-model="value1"-->
<!--              type="daterange"-->
<!--              range-separator="至"-->
<!--              start-placeholder="开始日期"-->
<!--              end-placeholder="结束日期">-->
<!--            </el-date-picker>-->
<!--          </el-row>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->
    <!-- 统计图 -->
    <div class="grid" data-column="2">
      <div :class="'grid-item grid-item-' + index" v-for="(item, index) in gridList">
        <div class="info-area">
          <div class="title">
            {{ item.title }}
          </div>
          <div >
            <div class="info-list">
              <div class="info-item" v-for="(info,iIndex) in item.infoList">
                <div class="info-tit">
                  {{ info.title }}
                </div>
                <div class="info-data">
                  {{info.data}}
                </div>
                <div class="info-desc">
                  较前一周期
                  <el-image
                    v-if="info"
                    class="info-icon"
                    style="width: 7px; height: 10px"
                    :src="info.desc.indexOf('-') == -1 ? iconUp:iconDown">
                  </el-image>
                  {{info.desc | absoluteVal}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="'paybox paybox_'+index" v-if="item.title !='TOP5商品支付金额' && item.title !='退款原因排行'">
          <myEchart :option="item.opt"/>
        </div>
        <div class="table-box" v-else>
          <el-table v-if="item.title =='TOP5商品支付金额'" size="small" :data="item.opt.dataList" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;" :header-cell-style="{ 'text-align': 'center' ,'background-color': '#F7F8FA'}">
            <el-table-column align="center" label="排名" type="index" width="60">
            </el-table-column>
            <el-table-column label="商品名称" >
              <template slot-scope="scope">
                <div class="flex-area">
                  <el-image
                    style="width: 30px; height: 30px"
                    :src=scope.row.imageUrl>
                    <div slot="error" class="image-slot">
                      <i>—</i>
                    </div>
                  </el-image>
                  <div class="name-area">
                    {{scope.row.name}}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品支付金额" prop="totalProduct"  width="100">
            </el-table-column>
          </el-table>
          <el-table v-if="item.title =='退款原因排行'" size="small" :data="item.opt.dataList" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;" :header-cell-style="{ 'text-align': 'center' ,'background-color': '#F7F8FA'}">
            <el-table-column align="center" label="排名" type="index" width="60">
            </el-table-column>
            <el-table-column label="退款原因" >
              <template slot-scope="scope">
                <div class="flex-area">
                  <div class="name-area">
                    {{scope.row.name}}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品退款金额" prop="productAmount"  width="100">
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>
  </div>
</template>
<script >
import Chart from 'echarts'
import myEchart from "./myEchart"
import { realTimePaymentAmount, paymentSituation, trafficOverview, transactionConversion, newAndOldCustomerTransactions, productTransactionRanking, returnOverview, paymentConversionRate, numberVisitors, reasonRefundTOP,numberPayers, placeOrder } from '@/api/statistics.js'

// import { getVipUserCount} from '../../api/system'
export default {
  name: "welcome",
  data() {
    return {
      loading: false, //是显示加载
      iconUp:require('@/assets/img/icon-up.png'),
      iconDown:require('@/assets/img/icon-down.png'),
      gridList:[
        {
          title:'实时支付金额',
          infoList:[],
          proportion:'',
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [{
                name: '实时支付金额',
                // icon: 'arrow'
              }],
              top: 1,
              left: 1,
              selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              // textStyle: {
              //   fontSize: 12,
              //   color: "#323232"
              // }
            },
            grid: {
              left: 50,
              right: 10,
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            series: [{
              name: '实时支付金额',
              //   type: 'bar',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#108ff9"]
              }
            }]
          },
        },
        {
          title:'支付概况',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [ {
                name: '支付金额'
              },
                {
                  name: '支付人数'
                },{
                  name: '支付订单数'
                },{
                  name: '支付商品件数'
                }],
              top: 1,
              left: 1,
              // selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              textStyle: {
                fontSize: 12,
                color: "#323232"
              }
            },
            grid: {
              left: '10%',
              right: '10%',
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis:[
              {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
              {
              // name: '支付订单数',
              // max: 100,
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },],
            series: [{
              name: '支付金额',
              //   type: 'bar',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#8692BA"]
              }
            },
              {
                name: '支付人数',
                //   type: 'bar',
                type: 'line',
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#64BAB7"]
                }
              },
              {
                name: '支付订单数',
                yAxisIndex: 1,
                type: 'line',
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#EBB378"]
                }
              },
              {
                name: '支付商品件数',
                type: 'line',
                yAxisIndex: 1,
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#E7E6A3"]
                }
              }]
          },
        },
        {
          title:'流量概况',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [ {
                name: '浏览量'
              },{
                  name: '访客数'
                },{
                name: '一体机访客数'
              }],
              top: 1,
              left: 1,
              // selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              textStyle: {
                fontSize: 12,
                color: "#323232"
              }
            },
            grid: {
              left: 50,
              right: 10,
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            series: [{
              name: '浏览量',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#8692BA"]
              }
            },
              {
                name: '访客数',
                type: 'line',
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#64BAB7"]
                }
              },
              {
                name: '一体机访客数',
                type: 'line',
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#BA6478FF"]
                }
              }]
          },
        },
        {
          title:'交易转化',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            series: [
              {
                name: '交易转化',
                type: 'funnel',
                min: 0,
                max: 100,
                minSize: '0%',
                maxSize: '100%',
                // emphasis: {
                //   label: {
                //     show: true,
                //     fontSize: 20,
                //     fontWeight: 'bold'
                //   }
                // },
                data: [
                ],
              }
            ]
          },
        },
        {
          title:'新老客户成交',
          infoList:[],
          opt:{
            // color:['#4BA3FE','#FCDC4D','#F47E7E'],
            // color:['#ff7f0e', '#2ca02c', '#d62728', '#c564be'],
            // title: {
            //   text: '用户信息',
            //   left: 10,
            //   top: 5,
            //   textStyle: {
            //     fontSize: 12,
            //     color: '#666'
            //   }
            // },

            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },

            // visualMap: {
            //   show: false,
            //   min: 80,
            //   max: 600,
            //   inRange: {
            //     colorLightness: [0, 1]
            //   }
            // },
            legend: {
              orient: 'horizontal',
              top: 1,
              left: 1,
            },
            series: [
              {
                name: '新老客户成交',
                type: 'pie',
                // radius: '50%',
                center: ['50%', '50%'],
                radius: ['60%', '35%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                // data: this.userinfoData,
                data: [
                  // {
                  //   value:1246314,
                  //   name:"用户数量"
                  // }
                ],
                // roseType: 'radius',
                // label: {
                //   normal: {
                //     textStyle: {
                //       color: 'rgba(0, 0, 0, 0.8)'
                //     }
                //   }
                // },
                // labelLine: {
                //   normal: {
                //     lineStyle: {
                //       color: 'rgba(0, 0, 0, 0.1)'
                //     },
                //     smooth: 0.2,
                //     length: 10,
                //     length2: 20
                //   }
                // },
                // itemStyle: {
                //   normal: {
                //     color: '#c23531',
                //     shadowBlur: 200,
                //     shadowColor: 'rgba(0, 0, 0, 0.5)'
                //   }
                // },

                animationType: 'scale',
                animationEasing: 'elasticOut',
                animationDelay: function (idx) {
                  return Math.random() * 200;
                }
              }
            ]
          }
        },
        {
          title:'TOP5商品支付金额',
          infoList:[],
          opt:{
            dataList:[]
          }
        },
        {
          title:'退款概况',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [ {
                name: '成功退款金额'
              },{
                name: '成功退款人数'
              },{
                name: '成功退款率'
              }],
              top: 1,
              left: 1,
              // selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              textStyle: {
                fontSize: 12,
                color: "#323232"
              }
            },
            grid: {
              // left: 50,
              // right: 10,
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis:[{
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },{
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            }],
            series: [{
              name: '成功退款金额',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#56678C"]
              }
            },{
                name: '成功退款人数',
                type: 'line',
                yAxisIndex: 1,
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#84BFC5"]
                }
              },{
                name: '成功退款率',
                type: 'line',
              yAxisIndex: 1,
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#F2E292"]
                }
              }]
          },
        },
        {
          title:'访问-支付转化率',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [ {
                name: '访问-支付转化率'
              }],
              top: 1,
              left: 1,
              // selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              textStyle: {
                fontSize: 12,
                color: "#323232"
              }
            },
            grid: {
              left: 50,
              right: 10,
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            series: [{
              name: '访问-支付转化率',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#56678C"]
              }
            }]
          },
        },
        {
          title:'访客数(人)',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [ {
                name: '访问-支付转化率'
              }],
              top: 1,
              left: 1,
              // selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              textStyle: {
                fontSize: 12,
                color: "#323232"
              }
            },
            grid: {
              left: 50,
              right: 10,
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            series: [{
              name: '访客数(人)',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#56678C"]
              }
            }]
          },
        },
        {
          title:'退款原因排行',
          infoList:[],
          opt:{
            dataList:[]
          }
        },
        {
          title:'支付人数（人）',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [{
                name: '支付人数（人）',
                // icon: 'arrow'
              }],
              top: 1,
              left: 1,
              selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              // textStyle: {
              //   fontSize: 12,
              //   color: "#323232"
              // }
            },
            grid: {
              left: 50,
              right: 10,
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            series: [{
              name: '支付人数（人）',
              //   type: 'bar',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#108ff9"]
              }
            }]
          },
        },
        {
          title:'下单概况',
          infoList:[],
          opt:{
            tooltip: {
              trigger: 'item'
            },
            legend: {
              data: [ {
                name: '下单金额'
              },
                {
                  name: '下单人数'
                },{
                  name: '下单订单数'
                },{
                  name: '下单商品件数'
                }],
              top: 1,
              left: 1,
              // selectedMode:false,
              // itemGap: 10,
              // itemWidth: 12,
              // itemHeight: 12,
              textStyle: {
                fontSize: 12,
                color: "#323232"
              }
            },
            grid: {
              left: '10%',
              right: '10%',
              top: 30,
              bottom: 30,
              borderWidth: 1
            },
            xAxis: {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                height: 70,
                interval: 0,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },
            yAxis:[{
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },{
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: "#999999",
                  width: 1
                }
              },
              axisLabel: {
                margin: 14,
                textStyle: {
                  fontSize: 10,
                  color: "#999999"
                }
              }
            },],
            series: [{
              name: '下单金额',
              //   type: 'bar',
              type: 'line',
              smooth: true,
              barGap: 0,
              data: [],
              barWidth: 10,
              itemStyle: {
                color: ["#8692BA"]
              }
            },
              {
                name: '下单人数',
                //   type: 'bar',
                type: 'line',
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#64BAB7"]
                }
              },
              {
                name: '下单订单数',
                yAxisIndex: 1,
                type: 'line',
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#EBB378"]
                }
              },
              {
                name: '下单商品件数',
                type: 'line',
                yAxisIndex: 1,
                smooth: true,
                barGap: 0,
                data: [],
                barWidth: 10,
                itemStyle: {
                  color: ["#E7E6A3"]
                }
              }]
          },
        }

      ],
      userinfoData:[],
      machineNo: '',
      type: 'day',
      value:'',
      value1:'',
      options: [{
          value: '选项1',
          label: '会员分析'
        }, {
          value: '选项2',
          label: '订单分析'
        }, {
          value: '选项3',
          label: '商品分析'
        },],

    }
  },
  // 导入组件
  components: {
    // 点聚合组件
    myEchart
  },
  filters:{
    absoluteVal(v) {
      let val = v
      if(val.indexOf('-') != -1) {
        val = val.slice(1)
      }
      return val
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.getUserInfoChartsData()
  },
  // 挂载结束状态(里面是操作)
  mounted() {

    this.$nextTick().then(() => {
      this.getInitData()


    })

    setTimeout(async () => {
      // let res = await getVipUserCount()
      // this.userinfoData = res.body
      // this.getpayNum()
    }, 0);
  },
  // 里面的函数只有调用才会执行
  methods: {
    getInitData() {
      this.getRealTimePaymentAmount()
      this.getPaymentSituation()
      this.getTrafficOverview()
      this.getTransactionConversion()
      this.getNewAndOldCustomerTransactions()
      this.getProductTransactionRanking()
      this.geRreturnOverview()
      this.getPaymentConversionRate()
      this.getNumberVisitors()
      this.getReasonRefundTOP()
      this.getNumberPayers()
      this.getPlaceOrder()
    },
    // 实时支付金额
    async getRealTimePaymentAmount() {
      const {body} = await realTimePaymentAmount()
      // title
      this.gridList.filter(function(item){
        if(item.title == "实时支付金额") {
          let item1 = {
            title:'',
            data:body.paymentAmount,
            desc:body.proportion.toString()
          }
          item.infoList.push(item1)

          for (let data of body.datas) {
            item.opt.xAxis.data.push(data.key)
            item.opt.series[0].data.push(data.value)
          }

          return
        }
      })
      // console.log(this.gridList)
    },
    // 支付概况
    async getPaymentSituation() {
      const {body} = await paymentSituation()
      this.gridList.filter(function(item){
        if(item.title == "支付概况") {
          let item1 = {
            title:'支付金额',
            data:body.payMoney,
            desc:body.payMoneyLastMonthCompare.toString()
          }
          item.infoList.push(item1)
          let item2 = {
            title:'支付人数',
            data:body.payNumber,
            desc:body.payNumberLastMonthCompare.toString()
          }
          item.infoList.push(item2)
          let item3 = {
            title:'支付订单数',
            data:body.payOrder,
            desc:body.payOrderLastMonthCompare.toString()
          }
          item.infoList.push(item3)
          let item4 = {
            title:'支付商品件数',
            data:body.payProductsNumber,
            desc:body.payProductsNumberLastMonthCompare.toString()
          }
          item.infoList.push(item4)
          console.log(item.infoList)
          for (let data of body.payList) {
            item.opt.xAxis.data.push(data.date)
            item.opt.series[0].data.push(data.payMoney)
            item.opt.series[1].data.push(data.payNumber)
            item.opt.series[2].data.push(data.payOrder)
            // item.opt.series[3].data.push(555)
            item.opt.series[3].data.push(data.payProductsNumber)
          }
          return
        }
      })
    },
    // 流量概况
    async getTrafficOverview() {
      const {body} = await trafficOverview()
      this.gridList.filter(function(item){
        if(item.title == "流量概况") {

          let item2 = {
            title:'浏览量',
            data:body.previews,
            desc:body.previewsLastMonthCompare.toString()
          }
          item.infoList.push(item2)
          let item1 = {
            title:'访客数',
            data:body.visitors,
            desc:body.visitorsLastMonthCompare.toString()
          }
          item.infoList.push(item1)
          let item3 = {
            title:'一体机访客数',
            data:body.ytVisitors,
            desc:body.ytVisitorsLastMonthCompare.toString()
          }
          item.infoList.push(item3)
          for (let data of body.trafficOverviewVOS) {
            item.opt.xAxis.data.push(data.date)
            item.opt.series[0].data.push(data.previews)
            item.opt.series[1].data.push(data.pageView)
            item.opt.series[2].data.push(data.ytPageView)
          }
          return
        }
      })
    },
    // 交易转化
    async getTransactionConversion() {
      const {body} = await transactionConversion();
      this.gridList.filter(function(item){
        if(item.title == "交易转化") {
          let item1 = {
            title:'访客数',
            data:body.visitors,
            desc:body.visitorsLastMonthCompare.toString()
          }
          item.infoList.push(item1)
          let item2 = {
            title:'下单人数',
            data:body.createOrder,
            desc:body.createOrderLastMonthCompare.toString()
          }
          item.infoList.push(item2)
          let item3 = {
            title:'支付人数',
            data:body.payOrder,
            desc:body.payOrderLastMonthCompare.toString()
          }
          item.infoList.push(item3)
          let item4 = {
            title:'访问-下单转化率(%)',
            data:body.orderConversionRate,
            desc:body.orderConversionRateLastMonthCompare.toString()
          }
          item.infoList.push(item4)
          let item5 = {
            title:'下单-支付转化率(%)',
            data:body.orderPaymentConversionRate,
            desc:body.orderPaymentConversionRateLastMonthCompare.toString()
          }
          item.infoList.push(item5)
          let item6 = {
            title:'访问-支付转化率(%)',
            data:body.paymentConversionRate,
            desc:body.paymentConversionRateLastMonthCompare.toString()
          }
          item.infoList.push(item6)
            let arr =[{}, {}, {}]
          arr[0].value = body.visitors,arr[0].name = 	'访客数',arr[0].itemStyle = {color:'#3C77D4'};
          arr[1].value = body.createOrder,arr[1].name = 	'下单人数',arr[1].itemStyle = {color:'#44C0D3'};
          arr[2].value = body.payOrder,arr[2].name = 	'支付人数',arr[2].itemStyle = {color:'#EDB541'};
            item.opt.series[0].data = arr

          return
        }
      })
    },
    // 新老客户成交
    async getNewAndOldCustomerTransactions() {
      const {body} = await newAndOldCustomerTransactions()
      this.gridList.filter(function(item){
        if(item.title == "新老客户成交") {
          let item1 = {
            title:'新成交客户数',
            data:body.newPayUser,
            desc:body.newPayUserLastMonthCompare.toString()
          }
          item.infoList.push(item1)
          let item2 = {
            title:'新成交客户支付金额',
            data:body.newPayUserPaymentAmount,
            desc:body.newPayUserPaymentAmountLastMonthCompare.toString()
          }
          item.infoList.push(item2)
          let item3 = {
            title:'老成交客户',
            data:body.oldPayUser,
            desc:body.oldPayUserLastMonthCompare.toString()
          }
          item.infoList.push(item3)
          let item4 = {
            title:'老成交客户支付金额',
            data:body.oldPayUserPaymentAmount,
            desc:body.oldPayUserPaymentAmountLastMonthCompare.toString()
          }
          item.infoList.push(item4)

          let arr =[{}, {}]
          arr[0].value = body.newPayUser,arr[0].name = 	'新成交客户',arr[0].itemStyle = {color:'#3979D1'};
          arr[1].value = body.oldPayUser,arr[1].name = 	'老成交客户',arr[1].itemStyle = {color:'#44C0D3'};
          item.opt.series[0].data = arr

          return
        }
      })
    },
    //TOP5商品支付金额
    async getProductTransactionRanking() {
        const {body} = await productTransactionRanking()
      this.gridList.filter(function(item){

        if(item.title == "TOP5商品支付金额") {
          item.opt.dataList = body
          return
        }
      })
    },
    //退款概况
    async geRreturnOverview() {
      const {body} = await returnOverview()
      this.gridList.filter(function(item){
        if(item.title == "退款概况") {
          let item1 = {
            title:'成功退款金额',
            data:body.refundAmount,
            desc:body.refundAmountLastMonthCompare.toString()
          }
          item.infoList.push(item1)
          let item2 = {
            title:'成功退款人数',
            data:body.refundPeople,
            desc:body.refundPeopleLastMonthCompare.toString()
          }
          item.infoList.push(item2)
          let item3 = {
            title:'成功退款率(%)',
            data:body.refundRate,
            desc:body.refundRateLastMonthCompare.toString()
          }
          item.infoList.push(item3)

          for (let data of body.returnOverviewVOList) {
            item.opt.xAxis.data.push(data.date)
            item.opt.series[0].data.push(data.refundAmount)
            item.opt.series[1].data.push(data.refundPeople)
            item.opt.series[2].data.push(data.refundRate)
          }
          return
        }
      })
    },
    //访问-支付转化率
    async getPaymentConversionRate() {
      const {body} = await paymentConversionRate()
      this.gridList.filter(function(item){
        if(item.title == "访问-支付转化率"){
          let item1 = {
            title:'',
            data:body.paymentConversionRate,
            desc:body.growth.toString()
          }
          item.infoList.push(item1)

          for (let data of body.conversionRateList) {
            item.opt.xAxis.data.push(data.date)
            item.opt.series[0].data.push(data.conversionRate)
          }
          return
        }
      })
    },
    //访客数(人)
    async getNumberVisitors() {
     const {body} = await numberVisitors()
      this.gridList.filter(function(item){
        if(item.title == "访客数(人)"){
          let item1 = {
            title:'',
            data:body.peopleNumber,
            desc:body.rate.toString()
          }
          item.infoList.push(item1)

          for (let data of body.numberVisitorsDataList) {
            item.opt.xAxis.data.push(data.date)
            item.opt.series[0].data.push(data.peopleNumber)
          }
          return
        }
      })
    },
    //退款原因排行
    async getReasonRefundTOP() {
      const {body} = await reasonRefundTOP()
      this.gridList.filter(function(item){

        if(item.title == "退款原因排行") {
          item.opt.dataList = body
          return
        }
      })
    },
    async getNumberPayers() {
      const {body} = await numberPayers()
      this.gridList.filter(function(item){
        if(item.title == "支付人数（人）") {
          let item1 = {
            title:'',
            data:body.peopleNumber,
            desc:body.peopleNumberLastMonthCompare.toString()
          }
          item.infoList.push(item1)

          for (let data of body.numberPayersVOList) {
            item.opt.xAxis.data.push(data.date)
            item.opt.series[0].data.push(data.peopleNumber)
          }
          return
        }
      })
    },
    //下单概况
    async getPlaceOrder() {
      const {body} = await placeOrder()
      this.gridList.filter(function(item){
        if(item.title == "下单概况") {
          let item1 = {
            title:'下单金额',
            data:body.payMoney,
            desc:body.payMoneyLastMonthCompare.toString()
          }
          item.infoList.push(item1)
          let item2 = {
            title:'下单人数',
            data:body.payNumber,
            desc:body.payNumberLastMonthCompare.toString()
          }
          item.infoList.push(item2)
          let item3 = {
            title:'下单订单数',
            data:body.payOrder,
            desc:body.payOrderLastMonthCompare.toString()
          }
          item.infoList.push(item3)
          let item4 = {
            title:'下单商品件数',
            data:body.payProductsNumber,
            desc:body.payProductsNumberLastMonthCompare.toString()
          }
          item.infoList.push(item4)

          for (let data of body.payList) {
            item.opt.xAxis.data.push(data.date)
            item.opt.series[0].data.push(data.payMoney)
            item.opt.series[1].data.push(data.payNumber)
            item.opt.series[2].data.push(data.payOrder)
            item.opt.series[3].data.push(data.payProductsNumber)
          }
          return
        }
      })
    },
// 获取用户信息数据
   async getUserInfoChartsData(){
      let res = await getVipUserCount()
      this.userinfoData = res.body
      this.chart = Chart.init(this.$refs.payNumEchart)
      this.chart.setOption(this.payNumoption)
    }
  }
};
</script>
<style>
.stbox {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  /* background: url('../../assets/img/home.jpg') no-repeat; */
  /* background-size: 100% 100%; */
}
.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}
.stsearch {
  text-align: center;
}
.text-c {
  text-align: center;
  /* margin-top: 20px; */
}
.st-gbox {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
  height: 40vh;
  box-sizing: border-box;
  padding: 10px;
}
.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
  height: 32vh;
}
.paybox_4{
  height: 200px;
}
.grid{
  display: grid;
  grid-gap: 20px;
  grid-auto-rows: minmax(10px, auto);
  /*grid-auto-rows:50px*/
}
/* 添加一个自定义的属性，做一个可配置的列数设置 */
[class^='grid'][data-column='1'] {
  grid-template-columns: repeat(1, 1fr);
}

[class^='grid'][data-column='2'] {
  grid-template-columns: repeat(2, 1fr);
}

[class^='grid'][data-column='3'] {
  grid-template-columns: repeat(3, 1fr);
}
[class^='grid'][data-column='4'] {
  grid-template-columns: repeat(4, 1fr);
}
.grid-item{
  border-radius: 5px;
  box-shadow: 0 0 6px 2px #dadada;
  padding: 10px;
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: center;*/
}

/*.grid-item:nth-child(odd){*/
/*  grid-column: 1;*/
/*}*/
/*.grid-item:nth-child(even){*/
/*  grid-column: 2;*/
/*}*/
.grid-item-0{
  grid-row: 1 / 9;
  /*height: 360px;*/
}
.grid-item-1{
  grid-row: 1 / 11;
  /*height: 440px;*/
}
.grid-item-2{
  grid-row: 9 /18;
}

.grid-item-3{
  grid-row: 11 /23;
  /*grid-column: 2;*/
}
.grid-item-4{
  grid-row: 18 / 28;
}
.grid-item-5{
  grid-row: 23 /31;
}
.grid-item-6{
  grid-row: 28 / 39;
  /*height: 440px;*/
}
.grid-item-7{
  grid-row: 31 / 40;
}
.grid-item-8{
  grid-row: 39 / 48;
}
.grid-item-9{
  grid-row: 40 / 49;
}
.grid-item-10{
  grid-row: 48/ 57;
}
.grid-item-11{
  grid-row: 49 / 60;
}
.info-area{

}
.title{
  font-size: 16px;
  color: #9C9C9C;
  margin-bottom: 10px;
}
.table-box{
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  margin-top: 20px;
}
.flex-area{
  display: flex;
  align-items: center;
}
.name-area{
  padding-left: 5px;
}
.desc{
  font-size: 12px;
  color: #9C9C9C;
  display: flex;
  align-items: center;
}
.info-list{
  display: flex;
  flex-wrap: wrap;
}
.info-item{
  flex: 1;
  max-width: 50%;
  width: 50%;
  min-width: 50%;
  margin-bottom: 20px;
}
.info-tit{
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #9C9C9C;
}
.info-data{
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
}
.info-desc{
  font-size: 12px;
  color: #9C9C9C;
  display: flex;
  align-items: center;
}
.info-icon{
  margin: 0 2.5px;
  width: 7px;
  height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue